import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Breadcrumb } from '@models/breadcrumb.model'; // Ajusta la ruta
import { Router, NavigationEnd, ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {
  private breadcrumbsSubject = new BehaviorSubject<Breadcrumb[]>([]);
  public breadcrumbs$: Observable<Breadcrumb[]> = this.breadcrumbsSubject.asObservable();

  // Rutas donde no se mostrarán breadcrumbs
  private excludedRoutes: string[] = ['/perfil'];

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const breadcrumbs: Breadcrumb[] = [];
      this.addBreadcrumb(root, [], breadcrumbs);

      // Verificar si la ruta actual está excluida
      const currentUrl = this.router.url.split('?')[0]; // Ignorar query params para la exclusión
      if (this.excludedRoutes.some(path => currentUrl.startsWith(path))) {
        this.breadcrumbsSubject.next([]); // Vaciar breadcrumbs para rutas excluidas
      } else {
        this.breadcrumbsSubject.next(breadcrumbs);
      }
    });
  }

  private addBreadcrumb(route: ActivatedRouteSnapshot | null, parentUrl: string[], breadcrumbs: Breadcrumb[]) {
    if (route) {
      const routeUrl = parentUrl.concat(route.url.map(url => url.path));
      if (route.data && route.data['breadcrumb']) {
        let label = route.data['breadcrumb'];
        // Para breadcrumbs dinámicos (ej. nombre de producto/categoría)
        if (route.data['breadcrumbParam']) {
            const paramName = route.data['breadcrumbParam'];
            label = route.params[paramName] || label; // Usa el valor del parámetro si existe
        }

        const breadcrumb = {
          label: this.isFunction(label) ? label(route.data) : label,
          url: '/' + routeUrl.join('/')
        };
        // Evitar duplicados si la URL es la misma (puede pasar con rutas hijas sin path)
        if (!breadcrumbs.find(b => b.url === breadcrumb.url)) {
             breadcrumbs.push(breadcrumb);
        }
      }
      this.addBreadcrumb(route.firstChild, routeUrl, breadcrumbs);
    }
  }

  private isFunction(value: any): value is Function {
    return typeof value === 'function';
  }

  // Método manual si se prefiere setear desde el componente (menos automático)
  setBreadcrumbs(breadcrumbs: Breadcrumb[]) {
    this.breadcrumbsSubject.next(breadcrumbs);
  }
}
